import React, { useRef, useContext, useEffect } from "react";
import { Card, CardActions, CardContent, Button, Grid } from "@mui/material";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
import { useForm } from "react-hook-form";
import { postCreateForm } from "../../../actions/admin/actionCreators";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import TextFieldComponent from "../../FormAddInputComponent/TextField";
import { AppBarSpacer, CardHeaderCss } from "../../../css/Admin-css/listing-css";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";

export default function AnnouncementCreate() {
    const { enqueueSnackbar } = useSnackbar();
    const {
        watch,
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        mode: "all",
        defaultValues: {
			name: "",
			nick_name: "",
			email: "",
			contact_no: "",
			password: "",
            confirm_password: "",
		},
    });

    const password = useRef({});
    password.current = watch("password");

    const api = useContext(AxiosContext);
    const navigate = useNavigate();

    const onSubmit = handleSubmit(async (data) => {
        document.getElementById("splash-screen").classList.remove("hidden");
        const response = await postCreateForm({
            api: api,
            data: data,
            method: "POST",
            url: "createSalesPerson",
            enqueueSnackbar,
        });

        if (response) {
            if (response.data.status === 200) {
                enqueueSnackbar(response.data.data.msg, {
                    variant: response.data.data.msgType,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                });
                if (response.data.data.msgType == 'success') navigate("/admin/sales-person-list");
            }
        }
        document.getElementById("splash-screen").classList.add("hidden");
    });

    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
        {
            text: "Sales Person",
            link: "/admin/sales-person-list",
        },
        {
            text: "Add Sales Person",
            link: "",
        },
    ]);

    useEffect(() => {
    }, []);

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
                <CollapsedBreadcrumbs />
            </BreadcrumbsContext.Provider>
            <Card>
                <CardHeaderCss title="Sales Person Form" />
                <CardContent>
                    <form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="nick_name"
                                    marginType="normal"
                                    label="Username"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^\S*$/,
                                            message: 'No space allowed for Username'
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="name"
                                    marginType="normal"
                                    label="Full Name"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="email"
                                    marginType="normal"
                                    label="Email Address"
                                    style={{ margin: 8 }}
                                    type="email"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "invalid email address"
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="contact_no"
                                    placeholder="Mobile No."
                                    marginType="normal"
                                    label="Mobile No."
                                    type="text"
                                    rules={{ required: true }}
                                    errors={errors}
                                    setValue={setValue}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="password"
                                    placeholder="Password"
                                    marginType="normal"
                                    label="Password"
                                    type="password"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must have at least 8 characters",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="confirm_password"
                                    placeholder="Confirm Password"
                                    marginType="normal"
                                    label="Confirm Password"
                                    type="password"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        minLength: {
                                            value: 8,
                                            message: "Password must have at least 8 characters",
                                        },
                                        validate: (value) =>
                                            value === password.current ||
                                            "The passwords do not match",
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
            <AppBarSpacer />
            <CardActions
                style={{ justifyContent: "center", marginBottom: "16px" }}
            >
                <div align="center">
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </CardActions>
        </>
    );
}
